module.exports = __webpack_public_path__ + "1ddf55360e6d3970497f79c0a1c2778a.jpg";